import { render, staticRenderFns } from "./Spaceship.vue?vue&type=template&id=6e00d13c&"
import script from "./Spaceship.vue?vue&type=script&lang=js&"
export * from "./Spaceship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports